import { useState, useEffect, Suspense, lazy } from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { FileText, BookOpen, Sparkles, Loader2, ShieldCheck } from "lucide-react";

const DocumentsPage = lazy(() => import("./docs/DocumentsPage"));
const ManualPage = lazy(() => import("./docs/ManualPage"));
const NovaManualPage = lazy(() => import("./docs/NovaManualPage"));
const GovernanceDocsPage = lazy(() => import("./docs/GovernanceDocsPage"));

export default function DocsPage() {
  const [params, setParams] = useSearchParams();
  const [tab, setTab] = useState(params.get("tab") || "documentos");
  useEffect(() => {
    if (tab !== params.get("tab")) setParams({ tab }, { replace: true });
  }, [tab]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="p-6 space-y-4" data-testid="docs-page">
      <div className="border-b pb-4">
        <div className="text-xs uppercase tracking-widest text-emerald-700 font-semibold mb-1">Innovation OS · Documentación</div>
        <h1 className="text-2xl font-bold tracking-tight">Documentación &amp; Manuales</h1>
        <p className="text-sm text-muted-foreground mt-1">Biblioteca de documentos I+D · Manual de la plataforma · Monográfico NOVA.</p>
      </div>

      <Tabs value={tab} onValueChange={setTab} className="space-y-4">
        <TabsList>
          <TabsTrigger value="documentos" data-testid="docs-tab-documentos"><FileText className="w-4 h-4 mr-2" />Documentos I+D</TabsTrigger>
          <TabsTrigger value="manual" data-testid="docs-tab-manual"><BookOpen className="w-4 h-4 mr-2" />Manual</TabsTrigger>
          <TabsTrigger value="nova" data-testid="docs-tab-nova"><Sparkles className="w-4 h-4 mr-2" />Monográfico NOVA</TabsTrigger>
          <TabsTrigger value="gobierno" data-testid="docs-tab-gobierno"><ShieldCheck className="w-4 h-4 mr-2" />Gobierno ISO</TabsTrigger>
        </TabsList>

        <div className="-mx-6 -mt-2">
          <Suspense fallback={<div className="p-12 flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-emerald-600" /></div>}>
            <TabsContent value="documentos" className="mt-0"><DocumentsPage /></TabsContent>
            <TabsContent value="manual" className="mt-0"><ManualPage /></TabsContent>
            <TabsContent value="nova" className="mt-0"><NovaManualPage /></TabsContent>
            <TabsContent value="gobierno" className="mt-0"><GovernanceDocsPage /></TabsContent>
          </Suspense>
        </div>
      </Tabs>
    </div>
  );
}
